import { BaseOption, OnSelectHandler } from 'ui/selectv2/types';
import { getValuesFromOptions } from '../utils/getValuesFromOptions';
import { useOnChangeValue } from '../../hooks/useOnChangeValue';

export const useUpdateOnSelect = (): OnSelectHandler => {
  const onChangeValue = useOnChangeValue();

  return (selectedOptions: BaseOption<string>[]) => {
    const values = getValuesFromOptions(selectedOptions);
    onChangeValue(values);
  };
};
